// SLAYER always lives on long after he's gone.
//
angular.module('dealerware.web.data').factory('DealerwareLoanerAgreementModel', function ($http, Model, DataUtils) {

    var dataUtils = DataUtils.getInstance();

    var model = new Model(
        {
            baseEndpoint: '/locations/:location_id/agreement_toggles',
            customActions:  {

                getBullets: {
                    method                          : 'GET',
                    endpoint                        : function (baseEndpoint) {
                        return baseEndpoint;
                    },
                    responseFormatter               : {
                        format: function (response) {
                            return mapAgreementToggleResponse(response);
                        }
                    },
                    ignoreDefaultRootNodeResponse: true,
                    ignoreAssociations: true
                },

                saveBullets: {
                    method                          : 'PUT',
                    endpoint                        : function (baseEndpoint) {
                        return baseEndpoint;
                    },
                    responseFormatter               : {
                        format: function (response) {
                            return mapAgreementToggleResponse(response);
                        }
                    },
                    ignoreAssociations: true
                },

                deleteBullet: {
                    method                          : 'DELETE',
                    endpoint                        : function (baseEndpoint) {
                        return baseEndpoint + '/:id';
                    },
                    responseFormatter               : {
                        format: function (response) {
                            return mapAgreementToggleResponse(response);
                        }
                    },
                    ignoreAssociations: true
                },

                getAgreementByContractId: {
                    method                          : 'GET',
                    endpoint                        : '/locations/:location_id/reservations/:reservation_id/rental_agreements/pdf',
                    rootNodeRequest                 : undefined,
                    actionMapper                    : undefined,
                    disabled                        : false,
                    isArray                         : false,
                    isCollection                    : false,
                    cache                           : false,
                    timeout                         : undefined,
                    withCredentials                 : false,
                    ignoreDefaultParams             : true,
                    ignoreDefaultRootNode           : true,
                    ignoreDefaultRootNodeResponse   : true,
                    ignoreDefaultRootNodeRequest    : true,
                    associationMapper               : undefined,
                    ignoreAssociations              : true,
                    ignoreDefaultAssociationMapper  : false
                },

                getAgreement: {
                    method                          : 'GET',
                    endpoint                        : '/locations/:location_id/rental_agreements/pdf?customer_only=true',
                    rootNodeRequest                 : undefined,
                    actionMapper                    : undefined,
                    disabled                        : false,
                    isArray                         : false,
                    isCollection                    : false,
                    cache                           : false,
                    timeout                         : undefined,
                    withCredentials                 : false,
                    ignoreDefaultParams             : true,
                    ignoreDefaultRootNode           : true,
                    ignoreDefaultRootNodeResponse   : true,
                    ignoreDefaultRootNodeRequest    : true,
                    associationMapper               : undefined,
                    ignoreAssociations              : true,
                    ignoreDefaultAssociationMapper  : false
                },


                updateAgreementPage: {
                    method                          : 'PUT',
                    endpoint                        : '/locations/:location_id/rental_agreements/:agreement_id'
                        + '/agreement_pages/:page_id',
                    ignoreAssociations              : true
                }
            },

            requestTransforms   : {
                create: function(data, args) {
                    if (data.id) { delete(data.id); }
                }
            },
            responseTransforms: {
                updateAgreementPage: function(args, data) {
                    var agreement_page = { };
                    Object.keys(data).forEach( function (key) {
                         agreement_page[key] = data[key];
                         delete data[key];
                    });
                    data.agreement_page = agreement_page;
                }
            },
            params              : undefined,
            responseFormatter   : undefined,
            associationMapper   : undefined,
            rootNodeRequest     : undefined
        });


    // This doesn't go through the normal Model code massaging because it's a pdf
    // upload that uses its own plugin. The endpoint is located here mainly to
    // keep it with all the Loaner Agreement endpoints.
    //
    jQuery.extend(model, {
        uploadAgreement: {
            endpoint: '/locations/:location_id/rental_agreements/pdf'
        }
    } );

    function mapAgreementToggleResponse (response) {

        return response.data.map( function (item) {

            return {
                id                  : item.id,
                text                : item.text,
                originalText        : item.text,
                createdAt           : item.created_at,
                createdAtDisplay    : dataUtils.pastDateWordify(item.created_at, false, true),
                modifiedAt          : item.updated_at,
                modifiedAtDisplay   : dataUtils.pastDateWordify(item.updated_at, false, true),
                sortOrderIndex      : item.numeric_order,
                mandatory           : item.mandatory,
            }
        });
    }

    return model;

});

/*
.config(function($provide) {
    $provide.decorator('LoanerAgreementModel', function($delegate, $injector) {
        return $injector.get('DealerwareLoanerAgreementModel');
    });
});
*/
